import { useCallback, useEffect, useMemo, useState } from "react";
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { shallowEqual, useSelector } from "umi";
import { getApiData } from "@/pages/dashboard/services/common";
import { PERIODTIMEOBJ } from "@/pages/dashboard/_config/constant";


const DEFAULT_METRIC_KEYS = ['d2', 'd3', 'd7'];

const buildInitialState = (metricKeys: string[]): Record<string, string | Array<{ time_dot: string; count: string; }>> => {
  const state: Record<string, string | Array<{ time_dot: string; count: string; }>> = {};
  metricKeys.forEach(key => {
    state[key] = [];
    state[`avg_${key}`] = '';
  });
  return state;
};

const useData = (api: string, filterVal: any, filterLoading: boolean, tag: string, extraParams?: Record<string, any>, metricKeys?: string[]) => {
  const keysToken = metricKeys?.join() ?? '';
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const keys = useMemo(() => metricKeys?.length ? metricKeys : DEFAULT_METRIC_KEYS, [keysToken]);

  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    };
  }, shallowEqual);

  const [componentData, setComponentData] = useState<Record<string, string | Array<{ time_dot: string; count: string; }>>>(
    () => buildInitialState(keys),
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const getRetentionTrendDataFunc = useCallback(() => {
    const { rangeTime, diff, timeType, rangeDaily, ...filters } = filterVal;
    const params = {
      game_code: gameCode,
      start_date: rangeTime?.[0],
      end_date: rangeTime?.[1],
      period: PERIODTIMEOBJ?.[timeType],
      filters: formatFilterValues(filters),
      retention_type: tag,
      ...(extraParams || {}),
    };
    setLoading(true);
    getApiData(api, params).then((result: any) => {
      const avgList = result?.aggregation?.find((item: any) => item?.type === 'avg') || {};
      const newData: Record<string, string | Array<{ time_dot: string; count: string; }>> = {};

      keys.forEach(key => {
        newData[`avg_${key}`] = avgList?.metrics?.[key]?.value || '';
        const list: Array<{ time_dot: string; count: string; }> = [];
        result?.metrics_list?.forEach((item: any) => {
          list.push({ time_dot: item?.date, count: item?.metrics?.[key]?.value || '' });
        });
        newData[key] = list;
      });

      setLoading(false);
      setError(false);
      setComponentData(newData);
    }).catch((err: any) => {
      console.log('getRetentionTrendDataFunc~err', err);
      setComponentData(buildInitialState(keys));
      setError(true);
      setLoading(false);
    });
  }, [filterVal, gameCode, api, tag, extraParams, keys]);

  useEffect(() => {
    if (!filterVal || filterLoading) return;
    getRetentionTrendDataFunc();
  }, [filterVal, filterLoading, getRetentionTrendDataFunc]);

  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
  };
};

export default useData;